import { Field, ID, InputType, ObjectType } from 'type-graphql'
import { Prop } from '@typegoose/typegoose'
import { ZendeskCommunication } from './ZendeskCommunication'
import { EmailCommunication } from './EmailCommunication'
import { generateEntityId } from '../generateEntityId'

@ObjectType()
@InputType('CommunicationInput')
export class Communication {
  @Field(() => ID)
  @Prop({ type: String, required: true, default: () => generateEntityId('comm') })
  _id: string

  @Field(() => [EmailCommunication])
  @Prop({ type: [EmailCommunication] })
  email: EmailCommunication[]

  @Field(() => [ZendeskCommunication])
  @Prop({ type: [ZendeskCommunication] })
  zendesk: ZendeskCommunication[]
}
